import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteStatus } from "../../../redux/slice/formUpdateSlice";
import DeleteBanner from "../../banners/crudOperations/deleteBanner";
import { updateMessage } from "../../../redux/slice/toastSlice";
import { consoleLog } from "../../../utils/log-utils";
import ParticipentReviewItem from "./participent-reviews-item";

function ParticipentReview() {
  const navigate=useNavigate();
  const location=useLocation();
  const participent=location.state.name;
  const dispatch=useDispatch();
  const [apiResult, setApiResult] = useState([]);

  const [searchVal, setSearchVal] = useState("");
 
  const showDeleteAlert=useSelector(deleteStatus);
  const [filterList, setFilterList] = useState([]);

  const [filterOptions, setfilterOptions] = useState({
    roleId: "",
  });

  // useEffect(() => {
  //   UserList();
  // }, []);
  // useEffect(() => {
  //   UserList();
  // }, [filterOptions]);

  // const UserList = async () => {
  //   let path= isFranchisLogin()?filterOptions.roleId+`&superUserId=${localStorage.getItem("userId")}`:filterOptions.roleId
  //   const data = await axios.get(

  //     API_CONFIG.API_HOST + USER_API_PATH.LIST_PATH+path,
  //     {
  //       headers: API_HEADERS,
  //     }
  //   );
  //   setApiResult(data.data.result);
  //   setFilterList(data.data.result)
  // };

  const handleChanges = (e) => {
    // const searchTerm=e.target.value
    // setfilterOptions(searchTerm)
    // consoleLog("search term",searchTerm)
    // const filterByRole=apiResult.filter(item=>{
    //   if(item.role_id===searchTerm){
    //    return item
    //   }
    // })
    // setFilterList(filterByRole)
    setfilterOptions({ ...filterOptions, [e.target.name]: e.target.value });
  };

  function handleSearchClick(e) {
    const searchTerm = e.target.value;
    setSearchVal(searchTerm);
    consoleLog("search Value", searchTerm);
      const filterBySearch = apiResult.filter((item) => {
        if (item.phone.includes(searchTerm)) {
          return item;
        }
      });
      setFilterList(filterBySearch);
   
  }

  const onSubmit = () => {
    
    dispatch(
      updateMessage({
        display: true,
        message: "Record deleted",
      })
    );
    // setBannerList([]);
    // UserList()

    // loadData();
  };



  {consoleLog("result",apiResult)}
  return (
    <>
    {showDeleteAlert && (
      <DeleteBanner 
        onSubmit={() => {
          onSubmit();
        }}
      />
    )}
    <main className="container-fluid dashboard">
      <div className="row m-3">
        <div className="row  tble">
          <div className="col-6">
            <h3 style={{color:"green"}}>{participent}</h3>
          </div>
        </div>
      </div>
      <div className="row m-3">
       
        <div className="col-12 col-md-3">
          {/* {
           !isFranchisLogin()&&<div className="form-group">
            <label>Role</label>
            <select
              name="roleId"
              className="form-select"
              onChange={(e) => handleChanges(e)}
              value={filterOptions.roleId}
            >
             
              <option value={""}>{"--Select Role--"}</option>
              {roleList &&
                roleList.length > 0 &&
                roleList.map((item, index) => {
                  return (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  );
                })}
            </select>
          </div>
          } */}
          
        </div>
        <div className="col-12 card-1 h-scroll">
          <table className="table table-hover align-middle">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Sno</th>
                <th scope="col">Member Name</th>
                <th scope="col">Vote</th>
                <th scope="col">Comment</th>  
                <th scope="col">Date & Time</th>
                {/* {
                  !isFranchisLogin()?<th scope="col">Actions</th>:""
                } */}
                
              </tr>
            </thead>

            <tbody>
              {filterList&& filterList.length>0?
              filterList.map((obj,i) => {
                return <ParticipentReviewItem item={obj} sno={i+1} key={obj.id} />;
              }):<>No Data</>
            }
            </tbody>
          </table>
        </div>
      </div>
    </main>
    </>
  );
}

export default ParticipentReview;